import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://mingyueculture.com';
const DEFAULT_IMAGE =
  'https://customer-assets.emergentagent.com/job_cultural-gateway-2/artifacts/njdciiht_%E9%99%B3%E9%8B%92%E7%8E%B2%E5%BD%A2%E8%B1%A1%E7%85%A7-%E9%BB%83.png';
const DEFAULT_KEYWORDS =
  '明悅文化, 明悅心創, Ming Yue Culture, 遊戲化學習, Game-based Learning, GBL, game, 遊戲, 高能動性, High Agency, 賦能, 成長, 學習, 財富流, 明日之星, 時空流, 生命教育, 企業教練, 陳鋒玲';

const SEO = ({
  title,
  description,
  keywords,
  path = '/',
  image = DEFAULT_IMAGE,
}) => {
  const fullTitle = title
    ? `${title}｜明悅文化 Ming Yue Culture`
    : '明悅文化 Ming Yue Culture｜遊戲化學習・高能動性 High Agency・賦能成長';
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords || DEFAULT_KEYWORDS} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:locale" content="zh_TW" />
      <meta property="og:site_name" content="明悅文化 Ming Yue Culture" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
